/**
  * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/TopLevelNavigationClick.proto
  *
  * @param {string} valueClicked - Event value, could be description of link or text value
  * @param {string} recommendationImpression - only send if there are recos inside the dropdown. Not applicable currently as we never do this. See evRecommendationImpression func.
*/
export const evTopLevelNavigationClick = ({ valueClicked, recommendationImpression }) => ({
  topLevelNavigationClick: {
    valueClicked,
    recommendationImpression
  }
});

/**
  * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/NavigationClick.proto
  *
  * @param {string} valueClicked - Event value, could be description of link or text value
  * @param {string} parentDropdown - parent dropdown, ex: 'Kids', 'Mens', etc.
  * @param {bool} searchOccurred - for when search form submitted inside dropdown
  * @param {object} explicitSearch (required when searchOccurred = true) - See evExplicitSearch
*/
export const evNavigationClick = ({ valueClicked, parentDropdown, searchOccurred, explicitSearch }) => ({
  navigationClick: {
    valueClicked,
    parentDropdown,
    searchOccurred,
    explicitSearch
  }
});

/**
  * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/ExplicitSearch.proto
  *
  * @param {string} term - string searched, ex: 'nike red shoes'
  * Note: searchType is always 'TYPED'. Only other is VOICE which we don't do.
*/
export const evExplicitSearch = ({ term }) => ({
  explicitSearch: {
    term,
    searchType: 'TYPED'
  }
});

/**
  * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/LandingPageComponentImpressionWrapper.proto
  *
  * @param {Object} dynamicBannerContent - Object with keys of:
  *   dynamic_banner_content: {
  *     contentType (string) ('STATIC' or 'DYNAMIC')
  *     text (string)
  *     imageUrl (string)
  *     link (string)
  *   }
*/
export const evDynamicBarImpressionWrapper = ({ dynamicBannerContent }) => ({
  landingPageComponentImpressionWrapper: {
    landingPageComponentImpression: [{ dynamicBannerContent }]
  }
});

/**
  * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/LandingPageComponentClick.proto
  *
  * @param {Object} dynamicBannerContent - Object with keys of:
  *   dynamic_banner_content: {
  *     contentType (string) ('STATIC' or 'DYNAMIC')
  *     text (string)
  *     imageUrl (string)
  *     link (string)
  *   }
*/
export const evDynamicBarClick = ({ dynamicBannerContent }) => ({
  landingPageComponentClick: {
    dynamicBannerContent
  }
});
